module.exports = __webpack_public_path__ + "img/Pellets-oel.6527fe6.webp";